import Vue from 'vue'
import axios from 'axios'
import Router from 'vue-router'
import Index from '@/page/index'
import paiwei from '@/page/paiwei'
import Friend from '@/page/friend'
import fast from '@/page/fast'
import Daily from '@/page/daily'
import DailyChallenge from '@/page/DailyChallenge'
import SelectChallenge from '@/page/selectChallenge'
import bank from '@/page/bank'
import book from '@/page/book'
import shop from '@/page/shop'
import spin from '@/page/spin'

import Language from '@/page/language'
import Faq from '@/page/faq'
import MyAccount from '@/page/myAccount'
import TermsAndCondition from '@/page/termsAndCondition'
import Login from '@/page/Login'
import otp from '@/page/otp'
import land from '@/page/land'
import Invitation from '@/page/invitation'
import Errors from '@/page/errors'

import rankList from '@/page/rankList'
import RankingChallenge from '@/page/rankingChallenge'
import Faq2 from '@/page/faq2'
import TermsAndCondition2 from '@/page/termsAndCondition2'
import BookRule from '@/page/bookRule'

Vue.use(Router)

export default new Router({
  routes: [
    {
		path: '/',
		name: 'index',
		component: Index,
		meta: {
			title: ''
		},
      beforeEnter: async (to, from, next) => {
        //路由守卫逻辑
        //路由带号码 直接登录
        if (to.query.mobile) {
          const res = await axios.post('https://demo-api.studygo.asia/api/user/fast_login', {
            mobile: to.query.mobile
          })
          if (res.data.code === 1){
            localStorage.setItem('token', res.data.data.userinfo.token)
            localStorage.setItem('mobile',res.data.data.userinfo.mobile)
          }
        }
        next()
      }
    },{
      path: '/paiwei',
      name: 'paiwei',
      component: paiwei,
      meta: {
        title: 'paiwei'
      }
    },{
      path: '/friend',
      name: 'Friend',
      component: Friend,
      meta: {
        title: 'Friend'
      }
    },{
      path: '/daily',
      name: 'daily',
      component: Daily,
      meta: {
        title: 'daily'
      }
    },{
      path: '/DailyChallenge',
      name: 'DailyChallenge',
      component: DailyChallenge,
      meta: {
        title: 'Daily Challenge'
      }
    },{
      path: '/selectChallenge',
      name: 'selectChallenge',
      component: SelectChallenge,
      meta: {
        title: 'Select Challenge'
      }
    },{
      path: '/bank',
      name: 'bank',
      component: bank,
      meta: {
        title: 'Piggy Bank'
      }
    },{
      path: '/book',
      name: 'book',
      component: book,
      meta: {
        title: 'Books'
      }
    },{
      path: '/shop',
      name: 'shop',
      component: shop,
      meta: {
        title: 'shop'
      }
    },{
      path: '/spin',
      name: 'spin',
      component: spin,
      meta: {
        title: 'spin'
      }
    },{
      path: '/rankList',
      name: 'rankList',
      component: rankList,
      meta: {
        title: 'rankList'
      }
    },{
      path: '/rankingChallenge',
      name: 'rankingChallenge',
      component: RankingChallenge,
      meta: {
        title: 'Ranking Challenge'
      }
    },
    {
		path: '/login',
		name: 'login',
		component: Login,
		meta: {
			title: 'Login'
		}
    },
    {
		path: '/otp',
		name: 'otp',
		component: otp,
		meta: {
			title: 'otp'
		}
    },
    {
		path: '/land',
		name: 'land',
		component: land,
		meta: {
			title: 'land'
		}
    },
    {
      path: '/invitation',
      name: 'invitation',
      component: Invitation,
      meta: {
        title: 'Invitation'
      }
    },{
		path: '/myAccount',
		name: 'myAccount',
		component: MyAccount,
		meta: {
			title: ''
		}
    },{
		path: '/faq',
		name: 'faq',
		component: Faq,
		meta: {
			title: 'faqs'
		}
    },{
		path: '/termsAndCondition',
		name: 'termsAndCondition',
		component: TermsAndCondition,
		meta: {
			title: 'Terms and Condition'
		}
    },
    {
      path: '/language',
      name: 'language',
      component: Language,
      meta: {
        title: 'language'
      }
    },
    {
      path: '/errors',
      name: 'errors',
      component: Errors,
      meta: {
        title: 'errors'
      }
    },{
      path: '/faq2',
      name: 'faq',
      component: Faq2,
      meta: {
        title: 'faqs'
      }
    },
    {
      path: '/termsAndCondition2',
      name: 'termsAndCondition',
      component: TermsAndCondition2,
      meta: {
        title: 'Terms and Condition'
      }
    },
    {
      path: '/fast',
      name: 'fast',
      component: fast,
      meta: {
        title: 'fast'
      }
    },
    {
      path: '/bookRule',
      name: 'bookRule',
      component: BookRule,
      meta: {
        title: 'bookRule'
      }
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js